import { Modal as CartDialog } from '../../components/Modal';
import { Share } from '../../components/ShareButton';
import { getSectionInnerHTML } from './refreshCart';

function getSectionToRender() {
  return {
    id: 'cart-share-modal',
    section: 'cart-share',
    selector: '.shopify-section',
  };
}

const share = () => {
  async function shareClickHandle() {
    const url = `${window.location.pathname}${
      window.location.search ? `${window.location.search}&` : '?'
    }sections=cart-share`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Response error is not okay');
        }
        return response.json();
      })
      .then((data) => {
        const sectionToRender = getSectionToRender();
        const dialogObj = new CartDialog(sectionToRender.id);
        dialogObj.setContent(getSectionInnerHTML(data[sectionToRender.section], sectionToRender.selector)).show();

        // Defer this block because they are not user-visible tasks
        setTimeout(() => {
          const shareInstance = new Share(dialogObj.node.querySelector('.cart-c-share'), '.cart-c');
          shareInstance.init();

          dialogObj.setClose(() => shareInstance.close());
        }, 0);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  document.getElementById('share-btn')?.addEventListener('click', shareClickHandle);
};

export default share;
